module.exports = __webpack_public_path__ + "/img/Header-Male-Right-Angle-4tb8uq.svg";